import PropTypes from 'prop-types';

import { ChatCenteredIcon, IconButtonV2, SideToolbar, StackIcon } from '@utilities';

import styles from './_index.module.scss';

const NarrativesNavigation = ({ activePage, onClick }) => {
  return (
    <SideToolbar
      tools={[
        <IconButtonV2
          className={activePage === 'landing' || activePage === 'chat' ? styles['active'] : ''}
          icon={<ChatCenteredIcon />}
          onClick={() => onClick('landing')}
          tooltip="Build with Chat"
          tooltipProps={{ placement: 'right' }}
          variant="subtle"
        />,
        <IconButtonV2
          className={activePage === 'templates' ? styles['active'] : ''}
          icon={<StackIcon />}
          onClick={() => onClick('templates')}
          tooltip="Browse Template Library"
          tooltipProps={{ placement: 'right' }}
          variant="subtle"
        />,
      ]}
    />
  );
};

NarrativesNavigation.propTypes = {
  activePage: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NarrativesNavigation;
